import { ICompanyInfoItemList } from '../modules/admin-panel/models';

export function mapToCompanyInfoList<T extends Record<string, number>>(
	info: T,
	infoKeys: Array<{
		key: keyof T;
		title: string;
	}>,
): ICompanyInfoItemList {
	return infoKeys.map(({ key, title }) => ({
		title,
		value: info ? info[key] : NaN,
	}));
}
